// material-ui
import { Typography } from '@mui/material';

// ==============================|| LOGO ||============================== //

const LogoMain = ({ reverse, ...others }: { reverse?: boolean }) => (
  <Typography
    variant="h4"
    component="span"
    sx={{
      fontWeight: 700,
      letterSpacing: '-0.02em',
      lineHeight: 1,
      whiteSpace: 'nowrap',
      color: reverse ? 'common.white' : 'text.primary'
    }}
    {...others}
  >
    Raya{' '}
    <Typography component="span" variant="inherit" sx={{ color: 'primary.main' }}>
      Console
    </Typography>
  </Typography>
);

export default LogoMain;
